import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProjects from '@atlassian/jira-navigation-apps-sidebar-global-settings-projects/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { trashProjectsDirectoryRoute } from '@atlassian/jira-router-routes-trash-projects-directory-routes/src/trashProjectsDirectoryRoute.tsx';
import TrashProjectsDirectory, {
	LazyTrashedProjectsAdmin,
} from './ui/admin-pages/trashed-projects/index.tsx';

export const trashProjectsDirectoryRouteEntry = createEntry(trashProjectsDirectoryRoute, () => ({
	group: 'global-settings',
	ufoName: 'admin.trashed-projects',
	component: TrashProjectsDirectory,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SIDEBAR_ID.GLOBAL_PROJECTS_SETTINGS,
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProjects,
	},

	resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	forPaint: [LazyAtlassianNavigation, LazyTrashedProjectsAdmin],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-trash-projects-directory-entries/src/trashProjectsDirectoryRouteEntry.tsx',
			whichExportToUse: 'trashProjectsDirectoryRouteEntry',
		},

		enabled: true,
	},
}));
